// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon;

module.exports.HiOutlineUserGroup = function HiOutlineUserGroup(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "strokeLinecap": "round",
        "strokeLinejoin": "round",
        "strokeWidth": "2",
        "d": "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
      }
    }]
  })(props);
};